import { render, staticRenderFns } from "./DebitOrderApprovalPage.vue?vue&type=template&id=6eb9b73d&scoped=true"
import script from "./DebitOrderApprovalPage.vue?vue&type=script&lang=js"
export * from "./DebitOrderApprovalPage.vue?vue&type=script&lang=js"
import style0 from "./DebitOrderApprovalPage.vue?vue&type=style&index=0&id=6eb9b73d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eb9b73d",
  null
  
)

export default component.exports